import type { ReactNode } from 'react';

interface MetricCardProps {
  label: string;
  value: ReactNode;
  note?: string;
  className?: string;
}

export function MetricCard({ label, value, note, className = '' }: MetricCardProps): React.JSX.Element {
  return (
    <article className={`metric-card ${className}`.trim()}>
      <span className="metric-card-label">{label}</span>
      <strong className="metric-card-value">{value}</strong>
      {note && <span className="metric-card-note">{note}</span>}
    </article>
  );
}
